// Daily lesson processing prompt.
// Called when Sir submits the evening Daily Recap form.
// JARVIS processes the recap and extracts all learnable data.
// Returns strict JSON only.

export const buildDailyRecapPrompt = (recap, context) => {
  const { behaviors = [], patterns = [], rules = [] } = context;

  return `Sir just submitted today's trading recap. Process it and extract every learnable insight.

TODAY'S RECAP:
Date          : ${recap.date}
Day           : ${recap.day_of_week}
Session traded: ${recap.session}
Market behavior: ${recap.market_behavior || 'Not provided'}
Key levels tested: ${recap.key_levels || 'Not provided'}
ICT observations: ${recap.ict_observations || 'Not provided'}
Patterns observed: ${recap.patterns_observed || 'Not provided'}
What worked   : ${recap.what_worked || 'Not provided'}
What failed   : ${recap.what_failed || 'Not provided'}
Trades today  : ${recap.trades_count || 0}
Overall result: ${recap.overall_result || 'NEUTRAL'}
Psychology    : ${recap.psychology_rating || 5}/10
Notes         : ${recap.notes || 'None'}

EXISTING BEHAVIORS TO COMPARE AGAINST (${behaviors.length}):
${behaviors.slice(0, 10).map(b =>
  `  [${b.id}] ${b.title} — seen ${b.observed_count}x, ${b.confidence} confidence`
).join('\n') || '  None yet'}

EXISTING PATTERNS TO COMPARE AGAINST (${patterns.length}):
${patterns.slice(0, 10).map(p =>
  `  [${p.id}] ${p.title} — ${p.win_rate}% win rate, ${p.total_occurrences}x seen`
).join('\n') || '  None yet'}

EXISTING RULES (${rules.length} active):
${rules.slice(0, 10).map(r =>
  `  [${r.id}] ${r.title} — ${r.win_rate}% win rate`
).join('\n') || '  None yet'}

Analyze this recap carefully and return ONLY valid JSON:

{
  "summary": "2–3 sentence summary of today's market action",
  "key_takeaway": "Single most important lesson from today",
  "jarvis_assessment": "JARVIS honest assessment of today's trading quality",
  "tomorrow_watch": "What Sir should watch for tomorrow based on today",

  "behaviors_confirmed": ["behavior_id_1", "behavior_id_2"],
  "behaviors_new": [
    {
      "title": "Behavior title",
      "category": "session or ict or time or news or dxy",
      "description": "What happened",
      "conditions": ["when it happens"],
      "typical_outcome": "What usually follows"
    }
  ],

  "patterns_confirmed": ["pattern_id_1"],
  "patterns_new": [
    {
      "title": "Pattern title",
      "conditions": ["element1", "element2"],
      "description": "Full pattern description"
    }
  ],

  "rules_to_update": [
    {
      "rule_id": "R001",
      "suggestion": "What to update and why",
      "urgency": "high or medium or low"
    }
  ],
  "rules_new": [
    {
      "title": "Rule title",
      "condition": "When to apply",
      "action": "BUY or SELL or WAIT",
      "notes": "Context"
    }
  ],

  "psychology_feedback": "JARVIS honest feedback on Sir's emotional state today",
  "discipline_note": "Did Sir follow the rules? Any observations?",
  "ict_observations": [
    {
      "type": "OB or FVG or Liquidity or BOS or CHoCH or AMD",
      "description": "What was observed"
    }
  ]
}`;
};
